import { useEffect } from 'react';
import { GlobalCSSVariable, useThemeContext } from '@/context/theme';
import { useActiveBundle } from '@/context/active-bundle';
import { AppBundle } from '@/utils/app-bundles';
import '../main-navigation/main-nav.css';

import { useLocalStorage } from '@/hooks/browser/use-local-storage';

import { Box, SideNav, useSideNavState } from '@customerio/pluma-components/react';
import { PlumaSideNav as PlumaSideNavCss } from '@customerio/pluma-components/css/components';

export const NAV_COLLAPSED_LOCAL_STORAGE_KEY = 'hydra:is-main-nav-collapsed';

const NAV_WIDTHS = {
  collapsed: Number.parseInt(PlumaSideNavCss.values.collapsedWidth),
  expanded: Number.parseInt(PlumaSideNavCss.values.expandedWidth),
};

export function MainNavigationWrapper(props: { isCollapsible?: boolean; children?: React.ReactNode }) {
  const { isCollapsible = true, children } = props;

  const activeApp = useActiveBundle();
  const themeContext = useThemeContext();
  const sideNavState = useSideNavState();

  // setup guide nav setup
  const [, setIsNavCollapsed] = useLocalStorage<boolean>(NAV_COLLAPSED_LOCAL_STORAGE_KEY, false);

  useEffect(() => {
    if (sideNavState != null) {
      setIsNavCollapsed(sideNavState.isCollapsed);
    }
  }, [setIsNavCollapsed, sideNavState]);

  useEffect(() => {
    const navWidth = sideNavState?.isCollapsed === true ? NAV_WIDTHS.collapsed : NAV_WIDTHS.expanded;
    themeContext.setVariable(GlobalCSSVariable.MainNavWidth, `${navWidth}px`);
  }, [sideNavState?.isCollapsed, themeContext]);

  return (
    <SideNav
      isCollapsible={isCollapsible}
      isCollapsed={!isCollapsible ? false : undefined}
      overflowY="auto"
      overflowX="hidden"
      aria-label="Main"
      style={{ scrollbarWidth: 'thin' }}
      pt="0"
    >
      {children}

      <Box mt="auto">
        {Object.values(AppBundle).map((bundle) => (
          <div
            key={bundle}
            id={`hydra-main-nav-footer-portal-${bundle}`}
            style={{ ...(activeApp !== bundle ? { display: 'none' } : {}) }}
          />
        ))}
      </Box>
    </SideNav>
  );
}
